/* eslint-disable react/prop-types */
import { pl } from 'date-fns/locale';
import React, { FC } from 'react';
import { DayPicker } from 'react-day-picker';
import { DefaultThemed } from '../ThemeProvider/ThemeProvider';
import {
  CaptionLabel,
  Day,
  DayButton,
  Month,
  MonthCaption,
  Months,
  Root,
  Week,
  Weekday,
} from './DatePicker.styles';
import { DatePickerProps } from './DatePicker.types';
import {
  formatCaption,
  formatWeekdayName,
  getNumberOfMonths,
} from './DatePicker.util';
import { NavButton } from './NavButton/NavButton';

export const DatePicker: FC<DatePickerProps> = ({ dayPickerProps }) => {
  return (
    <DefaultThemed>
      <DayPicker
        mode={dayPickerProps.mode ?? 'single'}
        required={dayPickerProps.required ?? true}
        selected={dayPickerProps['selected'] ?? undefined}
        locale={dayPickerProps.locale ?? pl}
        formatters={{ formatCaption, formatWeekdayName }}
        showOutsideDays={dayPickerProps.showOutsideDays ?? false}
        numberOfMonths={getNumberOfMonths(dayPickerProps)}
        components={{
          Root: (props) => <Root {...props}></Root>,
          CaptionLabel: (props) => <CaptionLabel {...props}></CaptionLabel>,
          Weekday: (props) => <Weekday {...props} />,
          MonthCaption: (props) => <MonthCaption {...props} />,
          Months: (props) => <Months {...props} />,
          Month: (props) => <Month {...props} />,
          Week: (props) => <Week {...props} />,
          Day: (props) => <Day {...props} />,
          DayButton: (props) => <DayButton {...props} />,
          PreviousMonthButton: (props) => (
            <NavButton
              disableNavigation={dayPickerProps.disableNavigation}
              disabledDates={dayPickerProps.disabled}
              navDirection={'previous'}
              {...props}
            />
          ),
          NextMonthButton: (props) => (
            <NavButton
              disableNavigation={dayPickerProps.disableNavigation}
              disabledDates={dayPickerProps.disabled}
              navDirection={'next'}
              {...props}
            />
          ),
          ...dayPickerProps.components,
        }}
        {...dayPickerProps}
      />
    </DefaultThemed>
  );
};
